// 헤더 아래 본문 가운데 정렬·max-width 1120 (디자인 QA 10/23 정정)
// 전체 폭 유지: 홈·처방전·환자관리·복약이행, 판매 인사이트 상세(전국·지역·취급률). 그 외 화면은 모두 1120 가운데
// 본문(MainLayout)과 헤더 탭 줄(Header → TabBar)이 같은 기준을 쓴다
const FULL_WIDTH_PATHS = ['/dashboard/home', '/dashboard/rx', '/dashboard/patient', '/dashboard/adherence'];

export const isCenteredScreen = ({ pathname, search }) =>
  !FULL_WIDTH_PATHS.includes(pathname) &&
  !(pathname === '/dashboard/insight' && ['national', 'region', 'pharmacy'].includes(new URLSearchParams(search).get('view')));
